// You'll need to have at least one of these permissions to access the Admin Section

export default [
  'tax_documents:create',
  'employee_registrations:read',
  'employee_registrations:create',
  'tax_documents_log:read',
];
